import React from 'react';
import ExpressionDetector from './ExpressionDetector';
import './App.css';

function App() {
  return (
    <div className="App">
      <ExpressionDetector />
    </div>
  );
}

export default App;